<template>
    <div v-if="showFlag" class="flag">
        <div class="fixed flex center middle between">
            <div class="content flex-1">
                <p>
                    <b>Não detectamos nenhuma Integração de Marketing Ativa!</b>!
                </p>
                <p class="margin-top-s">
                    Faça a configuração para Facebook Ads ou Google Ads. E ative suas contas de anúncio.
                </p>
                <div class="">
                    <div class="button primary margin-top-s" @click="closeMessage()">Fechar</div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>

import { mapState } from "vuex";

export default {
    name: 'flag-marketing',
    props: ['show'],
    data() {
        return {
            showFlag: false
        }
    },
    mounted() {
        this.showFlag = this.show
    },
    watch: {
        show() {
            this.showFlag = this.show
        }
    },
    computed: {
        ...mapState({
            account: (state) => state.account,
        }),
    },
    methods: {
        closeMessage() {
            this.$emit('close', false)
        }
    }
}
</script>

<style lang="scss" scoped>
.flag {
    margin-bottom: 60px
}
.fixed {
    position: absolute;
    z-index: 2;
    top: 0px;
    left: 80px;
    width: 100%;
    color: #333;
    background: #f79b06;
    height: auto;


    .content {
        width: 100%;
        text-align: left;
        font-size: 14px;
        min-height: 70px;
        height: auto;
        padding: 15px 90px 5px 5px;
        text-align: center;
    }

    .icon {
        margin-left: 90px;
        width: 70px;
        padding: 5px;
        font-size: 36px;
    }
}

@media screen and (max-width: 1024px) {
   .flag {
        margin-bottom: 110px;
    }
  .fixed {
    left:0px;
    .content {
        padding: 15px 30px 10px 10px;
    }
  }

}
</style>

<style>

@media screen and (max-width: 1024px) {
    .sidebar.isdemo {
        top: 115px !important;
    }
}
</style>
